import { uploadData } from 'aws-amplify/storage';
import { v4 as uuidv4 } from 'uuid';
import store from '../configureStore';
import { getExtFromFileName } from '../util/UtilFunctions';

export const putToStorageDefault = async (file: File | Blob, fileName: string) => {
  const rndUuid = uuidv4();
  const {
    workspace: { currentUserGroup },
    user: { identityId },
  } = store.getState();
  const fileExt = (file as File).name
    ? getExtFromFileName((file as File).name)
    : getExtFromFileName(fileName);
  const newFileName = `${currentUserGroup}/${rndUuid}.${fileExt}`;
  const task = uploadData({
    path: `private/${identityId}/${newFileName}`,
    data: file,
    options: { contentType: (file as File).type },
  });
  await task.result;
  return { key: newFileName };
};

export const putToStorageProfileImage = async (file: File | Blob, fileName: string) => {
  const rndUuid = uuidv4();
  const {
    user: { identityId },
  } = store.getState();
  const fileExt = (file as File).name
    ? getExtFromFileName((file as File).name)
    : getExtFromFileName(fileName);
  const newFileName = `${rndUuid}.${fileExt}`;
  const task = uploadData({
    path: `private/${identityId}/${newFileName}`,
    data: file,
    options: { contentType: (file as File).type },
  });
  await task.result;
  return { key: newFileName };
};

export const putToStorageResource = async (
  file: File,
  progressCallback?: (progress: { loaded: number; total: number }) => void,
) => {
  const {
    workspace: { currentUserGroup },
    user: { identityId },
  } = store.getState();
  const rndUuid = uuidv4();
  const fileExt = getExtFromFileName(file.name);
  const chosenFileType = file.type.split('/')[0];
  const updatedFileName = `${currentUserGroup}/${chosenFileType}-${rndUuid}.${fileExt}`;
  const task = uploadData({
    path: `private/${identityId}/${updatedFileName}`,
    data: file,
    options: {
      contentType: file.type,
      onProgress: progressCallback
        ? ({ transferredBytes, totalBytes }: { transferredBytes: number; totalBytes?: number }) =>
            progressCallback({ loaded: transferredBytes, total: totalBytes ?? 0 })
        : undefined,
    },
  });
  await task.result;
  return { key: updatedFileName };
};

export const putToStorageVideoSnapShot = async (blobData: Blob) => {
  const {
    workspace: { currentUserGroup },
    user: { identityId },
  } = store.getState();
  const rndUuid = uuidv4();
  const thumbnailNewFileName = `${currentUserGroup}/${rndUuid}.jpeg`;
  const task = uploadData({
    path: `private/${identityId}/${thumbnailNewFileName}`,
    data: blobData,
    options: { contentType: blobData.type },
  });
  await task.result;
  return { key: thumbnailNewFileName };
};

export const putToStorageTaskSnapShot = async (blobData: Blob) => {
  const rndUuid = uuidv4();
  const {
    workspace: { currentUserGroup },
    user: { identityId },
  } = store.getState();
  const newFileName = `${currentUserGroup}/task-${rndUuid}.jpeg`;
  const task = uploadData({
    path: `private/${identityId}/${newFileName}`,
    data: blobData,
    options: { contentType: blobData.type },
  });
  await task.result;
  return { key: newFileName };
};
